// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__27CdB","path":"style_path__214YR","arrow":"style_arrow__2P1sF"};